import {
  SnackbarCloseReason as MuiSnackbarCloseReason,
  Snackbar,
} from "@mui/material";
import { Alert } from "@platform/design-system";
import { useState } from "react";

type SnackbarCloseReason = MuiSnackbarCloseReason | "close";

interface Props {
  severity: "error" | "warning" | "info" | "success";
  onClose?: () => void;
  message: string | React.JSX.Element;
  title?: string | null;
  autoHideDuration?: number;
}

const Notification = ({
  severity,
  onClose = () => {},
  message,
  title = null,
  autoHideDuration,
}: Props): React.JSX.Element => {
  const [open, setOpen] = useState(true);

  const handleOnClose = (_: unknown, reason: SnackbarCloseReason): void => {
    if (reason === "timeout" || reason === "close") {
      setOpen(false);
      onClose();
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleOnClose}
      // Stacked by the toast service inside its own fixed container.
      sx={{ position: "static" }}
    >
      <Alert
        severity={severity}
        title={title}
        onClose={(e) => handleOnClose(e, "close")}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
export { Props };
